import { SearchPaginationQuery } from './';
import api from './_client';

export type ListPayload = SearchPaginationQuery;

export interface IdPayload {
    id: string;
}

export interface DataPayload {
    id?: string;
    data: any;
}

export const list = (payload: ListPayload) => api.get(`/documents`, { params: payload });

export const details = (payload: IdPayload) => api.get(`/document/${payload.id}`);

export const structure = () => api.get(`/structure`);

export const create = async (payload: any) => {
    const formData = new FormData();
    Object.keys(payload.data).forEach((payloadKey) => {
        formData.append(payloadKey, payload.data[payloadKey]);
    });
    return api.post(`/document`, formData);
};
export const update = (payload: DataPayload) => api.put(`/document/${payload.id}`, payload.data);

export const del = (payload: IdPayload) => api.delete(`/document/${payload.id}`);

export const content = (payload: IdPayload) => api.get(`/document/${payload.id}/content`);
